import React from 'react';
import { ArrowRight } from 'lucide-react';

const CTASection = ({ onDownload }) => {
  return (
    <section className="bg-white py-20 px-6">
      <div className="max-w-6xl mx-auto rounded-[2.5rem] bg-gradient-to-br from-[#0e9f6e] to-[#0b7d55] px-8 sm:px-16 py-20 text-center relative overflow-hidden">
        <div className="absolute -top-16 -left-16 w-72 h-72 rounded-full bg-white/10 blur-2xl" />
        <div className="absolute -bottom-20 -right-10 w-80 h-80 rounded-full bg-white/10 blur-3xl" />
        <div className="relative z-10">
          <h2 className="font-display text-4xl sm:text-6xl font-700 text-white leading-tight max-w-3xl mx-auto">
            Stop guessing your way to growth.
          </h2>
          <p className="text-white/80 mt-5 max-w-xl mx-auto">Download FLIX, set up in minutes, and take your first payment today.</p>
          <button onClick={onDownload} className="mt-9 inline-flex items-center gap-2 bg-white text-[#0b7d55] rounded-xl px-8 py-4 text-sm font-bold hover:bg-[#f0fdf7] hover:scale-[1.02] active:scale-95 transition-all">
            Get FLIX free <ArrowRight size={16} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
